/* eslint-disable react/prop-types */
import clsx from 'clsx';

/** A labelled password input wired to a Formik field, with its error below. */
const PortalPasswordField = ({ id, label, autoComplete, formik, name }) => (
  <div className="flex flex-col gap-1">
    <label className="form-label text-gray-900" htmlFor={id}>{label}</label>
    <label className="input">
      <input
        id={id}
        type="password"
        autoComplete={autoComplete}
        {...formik.getFieldProps(name)}
        className={clsx('form-control', { 'is-invalid': formik.touched[name] && formik.errors[name] })}
      />
    </label>
    {formik.touched[name] && formik.errors[name] && (
      <span role="alert" className="text-danger text-xs mt-1">{formik.errors[name]}</span>
    )}
  </div>
);

export { PortalPasswordField };
